// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"5fec17bc","135":"4ad7e19a","263":"c9606064","583":"e3de5c13","787":"944517e4","925":"28e7e521","979":"a18c3a7e"}[chunkId] + ".chunk.js";
};